<template>
    <div>
        <PCList v-if="windowWidth >=600" />
        <MobileList v-if="windowWidth <600" />
    </div>
</template>

<script>
    import Vue from 'vue';
    import PCList from '../products/PCList';
    import MobileList from '../products/mobileList';
    export default Vue.extend({
        components: { PCList, MobileList },
        created() {
            window.addEventListener(
                'resize',
                this.$store.commit('setWindowWidth')
            )
        },
        computed: {
            windowWidth() {
                return this.$store.state.windowWidth;
            },
            basedOnWindowWidth() {
                if (this.windowWidth > 600) {
                    return true;
                } return false;
            }
        }
    });
</script>
